import './css/App.css';
import { Coins } from './components/Coins';


function App() {
  return (
    <>
      <Coins />
    </>
  );
}

export default App;
